import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '../../theming/jssTypes';
import { Modal, Table } from 'antd';
import * as moment from 'moment';
const styles = (theme: ThemeType): CssType => ({
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    height: 300,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: 9,
    },
  },
});

class PriceDataListModal extends React.Component<any, any> {
  generateDataColumns = () => {
    const columnData: any = [
      {
        title: 'S.No.',
        key: 'index',
        render: (text, record, index) => index + 1,
        width: 10,
      },
      {
        title: 'Charge Name',
        key: 'id',
        width: 40,
        render: (text, record) => record['name'] || record['id'] || '',
      },
      {
        title: 'Charge Amount',
        key: 'value',
        width: 30,
        render: (text, record) => record['value'] ?? '',
      },
    ];
    return columnData;
  };
  render() {
    const { isVisible, classes, priceDataList } = this.props;
    const header = 'Details';
    return (
      <Modal
        title={header}
        width={500}
        visible={isVisible}
        footer={null}
        onCancel={() => this.props.handleModalClose(false)}
        destroyOnClose
      >
        <div className={classes.tableContainer}>
          <Table
            locale={{ emptyText: 'No Data Found' }}
            pagination={false}
            columns={this.generateDataColumns()}
            dataSource={priceDataList}
          />
        </div>
      </Modal>
    );
  }
}
export default withStyles(styles, { injectTheme: true })(PriceDataListModal);
